import { getAppConfig } from '@services/config';

import { disableTlsVerification } from '@helpers/disable-tls-verification';

import { SAPIC_X_VERSION } from '@constants/api';

import { axiosInstanceFactory } from './axios-instance-factory';
import { AxiosService } from './axios-service';

disableTlsVerification();

export const httpService = new AxiosService(axiosInstanceFactory(false), false);
export const externalHttpService = new AxiosService(axiosInstanceFactory(true));

export const apiHttpService = new AxiosService(axiosInstanceFactory(false), true);
export const vapiHttpService = new AxiosService(axiosInstanceFactory(false), true, false, SAPIC_X_VERSION.V5);
export const cmsHttpService = new AxiosService(
    axiosInstanceFactory(false, getAppConfig().axios.cmsTimeout),
    false,
    true,
);
